import RecoveryPassword from 'views/RecoverPassword';

const RecoveryPasswordRoutes = {
    path: '/recovery',
    element: <RecoveryPassword />
};

export default RecoveryPasswordRoutes;
